/* eslint-disable max-len */
function SingleLogo({
  width = 32, height = 32, className,
}) {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.78381 6.07119L15.4213 11.0672C15.7702 11.3018 16.2296 11.3018 16.5788 11.0672L24.2162 6.04671L16.6158 1.04069C16.2669 0.806097 15.8075 0.806097 15.4583 1.04069L7.78381 6.07119Z" fill="#2aabdf" />
      <path d="M31.8443 6.33275C31.6475 6.68581 31.3649 6.98304 31.0222 7.19749L17.1324 15.8933C16.4396 16.327 15.5599 16.327 14.8671 15.8933L0.977248 7.19749C0.63485 6.98304 0.352013 6.68553 0.155173 6.33275L0 6.0542V20.336C0 21.0617 0.373646 21.7363 0.98873 22.1214L14.8673 30.81C15.5602 31.2437 16.4399 31.2437 17.1327 30.81L31.0112 22.1214C31.6264 21.7363 32 21.0617 32 20.336V6.05443L31.8443 6.33275Z" fill="#06031F" />
    </svg>
  );
}

export default SingleLogo;
